import { Box } from '@mui/material';
import { useEffect, useState, useRef } from 'react';

const LazyLoadWrapper = ({ children, minHeight, threshold = 0.01, sx, ...props }) => {
    const [isVisible, setIsVisible] = useState(false);
    const elementRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsVisible(true);
                        observer.disconnect(); // Dejar de observar cuando ya es visible
                    }
                });
            },
            {
                root: null, // Observar el viewport completo
                threshold: threshold, // Porcentaje del componente que debe ser visible
            }
        );

        if (elementRef.current) {
            observer.observe(elementRef.current);
        }

        return () => {
            if (elementRef.current) observer.unobserve(elementRef.current);
        };
    }, []);

    return (
        <Box style={{ minHeight: minHeight ?? 50 }} ref={elementRef} {...props} sx={sx}>
            {isVisible ? children : null}
        </Box>
    );
};

export default LazyLoadWrapper;
